// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

function handleBlur(event) {

    this.onBlur(event.target.value);

}

function handleChange(event) {

    this.onChange(event.target.value);

}

const LabeledTextAreaWithBlur = ({className, errorMessage, highlightClass, isEditable, isValid, value, label, vsrMessage, ...props}) => {

    const modifiedClassName = getFieldClassName(className, isValid, highlightClass);

    return (
        <LabeledFormInput
            className={modifiedClassName}
            label={label}
        >
            <EditableField
                className={'preformatted'}
                isEditable={isEditable}
                value={value}
            >
                <textarea
                    {...props}
                    onBlur={props::handleBlur}
                    onChange={props::handleChange}
                    value={value}
                />
            </EditableField>
            {
                isValid ?
                    null :
                    <span className='error-message'>
                        <FormattedMessage id={errorMessage}/>
                    </span>
            }
            {
                vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
            }
        </LabeledFormInput>
    );

};

LabeledTextAreaWithBlur.displayName = 'LabeledTextAreaWithBlur';
LabeledTextAreaWithBlur.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledTextAreaWithBlur;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-text-area-with-blur.js